import { Col, Row } from "react-bootstrap";
import { Icon, IconButton, Tooltip } from "@mui/material";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import BMXSelectField from "../../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import { ResetTimeType } from "../../../../../../Utils/GlobalVariables/Secretary/SecretaryType";
import "./SettingsServiceFormStepTwo.scss";
const SettingsServiceFormStepThree = (props) => {
  const { t } = useTranslation();

  return (
    <div className="justify-content-start">
      <Row>
        <Col>
          <BMXSeparator title={t("global:service.quotation")} />
        </Col>
      </Row>
      <Row>
        <Col xs={6} className="my-1 ">
          <Field
            data-cy="SERVICE_QUOTATION_MARKETING_TEXT"
            name="SERVICE_QUOTATION_MARKETING_TEXT.value"
            component={BMXTextField}
            label={t("global:service.SERVICE_QUOTATION_MARKETING_TEXT")}
          />
        </Col>
        <Col xs={6} className="my-1 ">
          <Field
            data-cy="SERVICE_QUOTATION_FOOTER_TEXT"
            name="SERVICE_QUOTATION_FOOTER_TEXT.value"
            component={BMXTextField}
            label={t("global:service.SERVICE_QUOTATION_FOOTER_TEXT")}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SettingsServiceFormStepThree;
